import styled from 'styled-components';

export const Root = styled.div`
  align-items: center;
  background-image: linear-gradient(135deg, #5dbefc, #dd92fe);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;

  * {
    height: 100%;
    max-height: 50%;
    max-width: 40%;
    width: 100%;
  }
`;
